import { z } from "zod";
import { BaseOverlayConfig } from "../shared/config";
import { defineOverlay } from "../shared/functions";
export const TextToSpeechOverlay = defineOverlay({
    defaults: {
        demoMode: false,
        minAmount: 0,
        pitch: 1,
        showAllDonations: false,
    },
    details: {
        category: "tools",
        description: "Utilize Text-To-Speech to read your donations out loud on stream",
        features: ["Multiple voices", "Customizable pitch"],
        flags: {
            isNew: true,
            isVisible: true,
        },
        icon: "overlays/tts.png",
        name: "Donation Text To Speech",
        obsDimensions: {
            height: "183px",
            width: "382px",
        },
        path: "/overlays/tts/",
        shortDescription: "Use TTS to read your donations out loud on stream.",
        slug: "tts",
    },
    schema: BaseOverlayConfig.extend({
        autoStart: z
            .boolean()
            .default(() => TextToSpeechOverlay._config.defaults.autoStart)
            .optional(),
        minAmount: z
            .number()
            .min(0)
            .default(() => TextToSpeechOverlay._config.defaults.minAmount)
            .optional(),
        pitch: z
            .number()
            .min(0)
            .max(2)
            .default(() => TextToSpeechOverlay._config.defaults.pitch)
            .optional(),
        pollID: z.string().optional(),
        pollMapping: z.string().optional(),
        selectedVoice: z.string().optional(),
    }),
});
//# sourceMappingURL=tts.js.map